import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { routeFileSelector } from '../../../utilz/i18n';
import FormSelectBox from '../Inputs/FormSelectBox';

export const PSLOptions = [
  { value: 'BAR', label: 'BAR - Baroid' },
  { value: 'CMT', label: 'CMT - Cementing' },
  { value: 'CT', label: 'CT - Completion Tools' },
  { value: 'HDBS', label: 'HDBS - Halliburton Drill Bits & Services' },
  { value: 'PPS', label: 'PPS - Pipeline & Process Services' },
  { value: 'PE', label: 'PE - Production Enhancement' },
  { value: 'PS', label: 'PS - Production Solutions' },
  { value: 'SDS', label: 'SDS - Sperry Drilling Services' },
  { value: 'TSS', label: 'TSS - Testing and Subsea' },
  { value: 'WPS', label: 'WPS - Wireline and Perforating' },
  { value: 'AS', label: 'AS - Ancillary Support' },
  { value: 'AL', label: 'AL - Artificial Lift' },
  { value: 'HPM', label: 'HPM - Halliburton Project Management' },
  { value: 'LSS', label: 'LSS - Landmark Software & Services' },
  { value: 'CP', label: 'CP - Completion & Production Other' },
  { value: 'HC', label: 'HC - Halliburton Consulting' },
  { value: 'MC', label: 'MC - Multi-Chem' },
  { value: 'DE', label: 'DE - Drilling & Evaluation Other' },
];

const PSLSelector = ({
  name = 'psl',
  label,
  editMode = true,
  options,
  additionalOptions,
  placeholder = 'Select PSL',
  ...rest
}) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  return (
    <FormSelectBox
      name={name}
      label={label || t('translation:getQuote.shippingTermsSearch.psl.label')}
      editMode={editMode}
      placeholder={placeholder}
      options={options || [...PSLOptions, ...(Array.isArray(additionalOptions) ? additionalOptions : [])]}
      {...rest}
    />
  );
};

export default PSLSelector;
